import { Link } from "@tanstack/react-router";
import { RevealOnScroll } from "./RevealOnScroll";

export type DisciplineItem = {
  eyebrow: string;
  title: string;
  subtitle: string;
  href: string;
};

export function DisciplineGrid({ items }: { items: DisciplineItem[] }) {
  return (
    <RevealOnScroll>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {items.map((d) => (
          <Link
            key={d.href}
            to={d.href}
            className="group relative flex min-h-[160px] flex-col gap-3 rounded-md border border-rule bg-white p-6 text-sm transition-all hover:-translate-y-0.5 hover:border-cyan hover:shadow-[0_12px_40px_-20px_oklch(0.6_0.11_225/0.4)]"
          >
            <p className="font-mono text-[11px] uppercase tracking-wider text-ink-3 opacity-60">
              {d.eyebrow}
            </p>
            <h3 className="font-display text-xl text-ink leading-tight">{d.title}</h3>
            <p className="text-sm text-ink-3 leading-snug">{d.subtitle}</p>
            <span
              aria-hidden
              className="mt-auto self-end font-mono text-base text-ink-3 transition-colors group-hover:text-cyan-deep"
            >
              →
            </span>
          </Link>
        ))}
      </div>
    </RevealOnScroll>
  );
}
